export const item = [
    {
        id: 1,
        image: '/pictures/Projects/proja.png'
    },
    {
        id: 2,
        image: '/pictures/Projects/projb.png'
    },
    {
        id: 3,
        image: '/pictures/Projects/projc.png'
    },
    {
        id: 4,
        image: '/pictures/Projects/projd.png'
    },
]